module.exports = __webpack_public_path__ + "img/thomas.98e4f5dc.svg";